import { render, staticRenderFns } from "./SignAll.vue?vue&type=template&id=1972b852&scoped=true"
import script from "./SignAll.vue?vue&type=script&lang=js"
export * from "./SignAll.vue?vue&type=script&lang=js"
import style0 from "./SignAll.vue?vue&type=style&index=0&id=1972b852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972b852",
  null
  
)

export default component.exports